import { PhoneSchema } from "@/utils/commonSchema";
import {
  boolean,
  email,
  literal,
  null_,
  nullable,
  number,
  object,
  objectAsync,
  optional,
  pipe,
  string,
  toLowerCase,
  transform,
  trim,
  union,
  unionAsync,
  variantAsync,
} from "valibot";

export const RequestProgramFITInputSchema = variantAsync("type", [
  objectAsync({
    type: literal("authenticated"),
    travelId: number(),
  }),
  objectAsync({
    type: literal("anonymous"),
    email: pipe(string(), trim(), toLowerCase(), email("Adresse email invalide")),
    phone: unionAsync([
      pipe(
        literal(""),
        transform(() => null),
      ),
      PhoneSchema,
      null_(),
    ]),
    travelId: number(),
    // absent quand la demande part sans formulaire (visiteur déjà connu) => consentement non exprimé
    openTracking: optional(boolean()),
  }),
]);

export const RequestProgramFITOutputSchema = object({
  success: boolean(),
  email: string(),
  telephone: union([string(), null_()]),
  brochureOperationId: nullable(number()),
});

export type RequestProgramFITInputSchema = typeof RequestProgramFITInputSchema;
export type RequestProgramFITOutputSchema = typeof RequestProgramFITOutputSchema;
